import React from 'react';
import PropTypes from 'prop-types';
import { Route } from '@common/components';
import { AuthTemplate } from '@identity/components/auth-template/auth-template';

export function PublicRoute({ component: Component, ...rest }) {
  return (
    <Route
      {...rest}
      render={(matchProps) => (
        <AuthTemplate>
          <Component {...matchProps} />
        </AuthTemplate>
      )}
    />
  );
}

PublicRoute.propTypes = {
  component: PropTypes.func,
};
